import React, { useEffect } from "react";
import "./EventDetails.css";
import Navbar from "../../components/NavBar/NavBar";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { useGetRendering, usePostRendering } from "../../hooks/useGetRendering";
import { useState } from "react";
import { BsCalendarEvent } from "react-icons/bs";
import { GoPrimitiveDot } from "react-icons/go";
import langSwitching from "../../algorithms/languageSwitching";
import { ButtonBase } from "@material-ui/core";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import {
  fullDate,
  getDayNumber,
  getMonth,
  getYear,
} from "../../algorithms/date";
import { MdLocationPin } from "react-icons/md";
import { CiYoutube } from "react-icons/ci";
import filesPaths, { shareUrl, userPhoto } from "../../paths/paths";
import { substringContent } from "../../algorithms/substringContent";
import ShareComponent from "../../components/ShareComponent/Share";
import Menu from "@mui/material/Menu";
import AddFavourites from "../../components/AddFavourites/AddFavourites";
import { StarHalf } from "@material-ui/icons";
import Keyword from "../../components/Keyword/Keyword";
import MoreListing from "../../components/MoreListing/MoreListing";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import parse from "html-react-parser";
import RatingComponent from "../../components/Rating/Rating";
import LoadingPopup from "../../components/LoadingPopup/LoadingPopup";
import { useSelector } from "react-redux";
import BackIcon from "../../components/BackIcon/BackIcon";
import Button from "../../components/Button/Button";
import { IoShareSocialOutline } from "react-icons/io5";
import attachmentSwitching from "../../algorithms/attachmentSwitching";
import { AiFillFilePdf } from "react-icons/ai";
import { getAttachmentPath } from "../../algorithms/getObjectData";
import con1pdf from "../../utils/files/con1.pdf";
import con2pdf from "../../utils/files/con2.pdf";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";
import { Row } from "react-bootstrap";

// import Rating from 'react-rating'
const EventDetails = () => {
  const [swiper, setSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [favoriteRerender, setFavoriteRerender] = useState(false);
  const { t, i18n } = useTranslation();
  let lang = i18n.language;
  const { id } = useParams();
  const [eventDetails, setEventDetails] = useState();
  // useGetRendering(`EventAPI/GetEventDetails/${id}`, setEventDetails, [
  //   id,
  //   favoriteRerender,
  // ])
  const user = useSelector((state) => state.userDataReducer.user);
  usePostRendering(
    "EventAPI/GetEventDetails",
    setEventDetails,
    {
      id,
      ownerId: user,
    },
    [id, favoriteRerender, user]
  );
  const [anchorEl, setAnchorEl] = useState(false);
  const open = anchorEl;
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(false);
  };
  const [comingEvents, setComingEvents] = useState();
  usePostRendering(
    "EventAPI/GetAllUpcomingEvent",
    setComingEvents,
    {
      ownerId: user,
      lang: lang === "ar-EG" ? "" : "en",
    },
    [favoriteRerender, user, lang]
  );

  useEffect(() => {
    if (eventDetails?.result && comingEvents) {
      let elements = document.getElementsByTagName("*");
      for (let i = 0; i < elements?.length; i++) {
        const element = elements[i];
        element.style.fontFamily =
          i18n.language == "ar-EG" ? "Almarai" : "Roboto";
      }
    }
  }, [i18n.language, eventDetails?.result, comingEvents]);
  const [rating, setRating] = useState(
    eventDetails?.result?.rateContent ?? null
  );
  useEffect(() => {
    let elements = document.querySelectorAll(".event-decription-content *");
    for (let i = 0; i < elements?.length; i++) {
      const element = elements[i];

      element.style.lineHeight = "32px";
      // element.style.fontSize = '18px'
    }
  }, [eventDetails?.result, lang]);
  const nextSlide = () => {
    swiper.slideNext();
    setActiveIndex(swiper.activeIndex);
  };

  const prevSlide = () => {
    swiper.slidePrev();
    setActiveIndex(swiper.activeIndex);
  };


  useEffect(() => {
    setActiveIndex(0);
  }, [lang]);

  return (
    <>
      <Helmet>
        <title>
          {parse(
            `${langSwitching(
              lang,
              eventDetails?.result?.titleA,
              eventDetails?.result?.titleE
            )}`
          )}
        </title>
        <meta
          property="og:image"
          name={langSwitching(lang, eventDetails?.result?.titleA)}
          content={`${
            eventDetails?.result?.photoE !== null
              ? `${langSwitching(
                  lang,
                  filesPaths.EventPhotoA,
                  filesPaths.EventPhotoE
                )}/${eventDetails?.result?.id}/${langSwitching(
                  lang,
                  eventDetails?.result?.photoA,
                  eventDetails?.result?.photoE
                )}`
              : `${filesPaths.EventPhotoA}/${eventDetails?.result?.id}/${eventDetails?.result?.photoA}`
          }`}
        />
        <meta
          property="og:title"
          name={langSwitching(
            lang,
            eventDetails?.result?.titleA,
            eventDetails?.result?.titleE
          )}
          content={langSwitching(
            lang,
            eventDetails?.result?.titleA,
            eventDetails?.result?.titleE
          )}
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="600" />
      </Helmet>
      <Navbar lang={lang} t={t} />
      {eventDetails?.result ? (
        <div className="event-details-wrapper">
          <div className="event-details-card-wrapper">
            <div className="ctr">
              <div className="details-card-content">
                <div className="ctr">
                  <div className="title-icon">
                    <div className="event-card-details-category">
                      <div>
                        <Link to="/Event">
                          {" "}
                          <span>
                            {" "}
                            <BsCalendarEvent />
                          </span>
                          <span className="mx-2">{t("Event")}</span>
                        </Link>
                      </div>
                      <div>
                        <span>
                          <GoPrimitiveDot />
                        </span>
                        <span>
                          {langSwitching(
                            lang,
                            eventDetails?.result?.eventCategoryName,
                            eventDetails?.result?.eventCategoryNameE
                          )}
                        </span>
                      </div>
                    </div>
                    <BackIcon iconColor={"#DF1E26"} color={"white"} />
                  </div>
                  <div className="details-card-wrapper">
                    <div className="event-card-details">
                      <div className="event-details-card-title">
                        <h1>
                          {parse(
                            `${langSwitching(
                              lang,
                              eventDetails?.result?.titleA,
                              eventDetails?.result?.titleE
                            )}`
                          )}
                        </h1>
                      </div>
                      <div className="event-details-card-date">
                        {fullDate(eventDetails?.result?.startDate)}
                      </div>
                      {langSwitching(
                        lang,
                        eventDetails?.result?.addressA,
                        eventDetails?.result?.addressE
                      ) && (
                        <div className="event-details-card-location">
                          <span>
                            {" "}
                            <MdLocationPin />
                          </span>
                          <span>
                            {langSwitching(
                              lang,
                              eventDetails?.result?.addressA,
                              eventDetails?.result?.addressE
                            )}
                          </span>
                        </div>
                      )}
                      {langSwitching(
                        lang,
                        eventDetails?.result?.urlA,
                        eventDetails?.result?.urlE
                      ) && (
                        <div className="event-youtube-link">
                          <span>
                            <CiYoutube />
                          </span>
                          <a
                            target="_blank"
                            href={langSwitching(
                              lang,
                              eventDetails?.result?.urlA?.includes("http")
                                ? eventDetails?.result?.urlA
                                : "//" + eventDetails?.result?.urlA,
                              eventDetails?.result?.urlE?.includes("http")
                                ? eventDetails?.result?.urlE
                                : "//" + eventDetails?.result?.urlE
                            )}
                          >
                            <span className="mx-2">{t("EventLink")}</span>
                          </a>
                        </div>
                      )}
                      {langSwitching(
                        lang,
                        eventDetails?.result?.keywordNamesA,
                        eventDetails?.result?.keywordNamesE
                      ) && (
                        <div className="event-some-keywords">
                          {lang === "ar-EG" ? (
                            <>
                              {eventDetails?.result?.keywordNamesA
                                ?.split(",")
                                ?.slice(0, 3)
                                ?.map((word) => (
                                  <>
                                    {word?.length > 0 && (
                                      <Keyword
                                        word={word}
                                        searchKeyword={word}
                                        key={word}
                                        className="light-keyword"
                                      />
                                    )}
                                  </>
                                ))}
                            </>
                          ) : (
                            <>
                              {lang === "en-US" && (
                                <>
                                  {eventDetails?.result?.keywordNamesE
                                    ?.split(",")
                                    ?.slice(0, 3)
                                    ?.map((word) => (
                                      <>
                                        {word?.length > 0 && (
                                          <Keyword
                                            word={word}
                                            searchKeyword={word}
                                            key={word}
                                            className="light-keyword"
                                          />
                                        )}
                                      </>
                                    ))}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="event-registration-time">
                      {eventDetails?.result?.startDate ===
                      eventDetails?.result?.endDate ? (
                        <div
                          className={
                            eventDetails?.result?.startDate ===
                            eventDetails?.result?.endDate
                              ? "event-card-time only-start-date-card-time "
                              : "event-card-time"
                          }
                        >
                          <div className="event-card-start-time only-event-start-date">
                            <span>
                              {getDayNumber(eventDetails?.result?.startDate)}
                            </span>
                            <span className="event-details-month-year">
                              <span>
                                {getMonth(eventDetails?.result?.startDate)}
                              </span>
                              <span className="mx-1">
                                {getYear(eventDetails?.result?.startDate)}
                              </span>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="event-card-time">
                          <div className="event-card-start-time">
                            <span>
                              {getDayNumber(eventDetails?.result?.startDate)}
                            </span>
                            <span className="event-details-month-year">
                              <span>
                                {getMonth(eventDetails?.result?.startDate)}
                              </span>
                              <span className="mx-1">
                                {getYear(eventDetails?.result?.startDate)}
                              </span>
                            </span>
                          </div>
                          <span>:</span>
                          <div className="event-card-end-time">
                            <span>
                              {getDayNumber(eventDetails?.result?.endDate)}
                            </span>
                            <span className="event-details-month-year">
                              <span>
                                {getMonth(eventDetails?.result?.endDate)}
                              </span>
                              <span className="mx-1">
                                {getYear(eventDetails?.result?.endDate)}
                              </span>
                            </span>
                          </div>
                        </div>
                      )}

                      {/* <div className="attendance-registration">
                        <button>{t('AttendanceRegistration')}</button>
                      </div> */}
                    </div>
                  </div>
                  <div className="rating-and-sharing">
                    <div className="card-stars-rating">
                      {user && (
                        <div className="card-stars">
                          <RatingComponent
                            rating={eventDetails?.result?.rateContent ?? null}
                            setRating={setRating}
                            id={eventDetails?.result?.id}
                            item={eventDetails?.result}
                            favoriteRerender={favoriteRerender}
                            setFavoriteRerender={setFavoriteRerender}
                          />
                        </div>
                      )}

                      <div className="card-rating-result">
                        <span className="rate-result-stars">
                          <StarHalf />
                          {eventDetails?.result?.rateContent > 0 && (
                            <span className="event-rate-result-span">
                              <span>5</span>/{eventDetails?.result?.rateContent}
                            </span>
                          )}
                        </span>
                        {eventDetails?.result?.rateContent && (
                          <span className="voting-number mx-3">
                            ({eventDetails?.result?.rateCount})
                          </span>
                        )}
                      </div>
                    </div>
                    <div
                      className={
                        eventDetails?.result?.startDate ===
                        eventDetails?.result?.endDate
                          ? "share-favourite-event only-date-of-start"
                          : "share-favourite-event"
                      }
                    >
                      <span className="favourite-coming-event-icon">
                        {" "}
                        <AddFavourites
                          size={30}
                          item={eventDetails?.result}
                          favoriteRerender={favoriteRerender}
                          setFavoriteRerender={setFavoriteRerender}
                        />
                      </span>
                      <span>
                        <IoShareSocialOutline
                          color="#a2a2a2"
                          size="30"
                          onClick={handleClick}
                        />
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          style={{ boxShadow: "none" }}
                        >
                          <ShareComponent
                            url={`${shareUrl}/Event/details/${eventDetails?.result?.id}`}
                            close={handleClose}
                            item={eventDetails?.result}
                          />
                        </Menu>
                      </span>
                      {attachmentSwitching(
                        lang,
                        eventDetails?.result?.attachmentA,
                        eventDetails?.result?.attachmentE
                      ) && (
                        <span className="details-attachement-icon">
                          <a
                            className="mx-1"
                            target="_blank"
                            href={getAttachmentPath(lang, eventDetails?.result)}
                          >
                            {" "}
                            <AiFillFilePdf
                              size={30}
                              color="rgb(162, 162, 162)"
                            />
                          </a>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {id == 916 && (
                <div className="pdfs my-4">
                  <span>
                    <a
                      href={con1pdf}
                      target="_blank"
                      style={{ color: "black", fontSize: "18px" }}
                    >
                      <AiFillFilePdf size={30} color="rgb(162, 162, 162)" />
                      <span className="mx-2">{t("con1")}</span>
                    </a>
                  </span>
                  <span className="mx-3">
                    <a
                      href={con2pdf}
                      target="_blank"
                      style={{ color: "black", fontSize: "18px" }}
                    >
                      <AiFillFilePdf size={30} color="rgb(162, 162, 162)" />{" "}
                      <span>{t("con2")}</span>
                    </a>
                  </span>
                  {attachmentSwitching(
                        lang,
                        eventDetails?.result?.attachmentA,
                        eventDetails?.result?.attachmentE
                      ) && (
                        <span className="details-attachement-icon">
                          <a
                            target="_blank"
                            href={getAttachmentPath(lang, eventDetails?.result)}
                            style={{ color: "black", fontSize: "18px" }}
                          >
                            {" "}
                            <AiFillFilePdf
                              size={30}
                              color="rgb(162, 162, 162)"
                            />
                            <span>{t("con3")}</span>
                          </a>
                        </span>
                      )}
                </div>
              )}

              <div className="ctr event-ctr">
                <div className="event-more-details">
                  {attachmentSwitching(
                    lang,
                    eventDetails?.result?.photosAlbum,
                    eventDetails?.result?.photosAlbum
                  ) && (
                    <div
                      className="event-details-image"
                      // style={{
                      //   backgroundImage: `url("${
                      //     eventDetails?.result?.photoE !== null
                      //       ? `${langSwitching(
                      //           lang,
                      //           filesPaths.EventPhotoA,
                      //           filesPaths.EventPhotoE,
                      //         )}/${eventDetails?.result?.id}/${langSwitching(
                      //           lang,
                      //           eventDetails?.result?.photoA,
                      //           eventDetails?.result?.photoE,
                      //         )}`
                      //       : `${filesPaths.EventPhotoA}/${eventDetails?.result?.id}/${eventDetails?.result?.photoA}`
                      //   }")`,
                      // }}
                    >
                      {eventDetails?.result?.photosAlbum?.length >
                        0 && (
                        <Row>
                          <div
                            className={`d-flex mb-3 ${
                              lang === "ar-EG"
                                ? "flex-row-reverse justify-content-start"
                                : "flex-row justify-content-end"
                            }`}
                          >
                            <ButtonBase
                              style={{
                                width: 35,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 10,
                                borderRadius: 7,
                                boxShadow: "0 1px 3px rgb(0 0 0 / 10%)",
                                cursor:
                                  lang === "ar-EG"
                                    ? activeIndex ===
                                    eventDetails?.result?.photosAlbum
                                        ?.length 
                                      ? "unset"
                                      : "pointer"
                                    : activeIndex === 0
                                    ? "unset"
                                    : "pointer",
                                backgroundColor:
                                  lang === "ar-EG"
                                    ? activeIndex ===
                                    eventDetails?.result?.photosAlbum
                                        ?.length 
                                      ? "rgb(243 123 128)"
                                      : "#DF1E26"
                                    : activeIndex === 0
                                    ? "rgb(243 123 128)"
                                    : "#DF1E26",
                                color: "#fff",
                              }}
                              className="buttons nxt-slide"
                              onClick={lang === "ar-EG" ? nextSlide : prevSlide}
                            >
                              <IoIosArrowBack size={22} />
                            </ButtonBase>
                            <ButtonBase
                              style={{
                                width: 35,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 7,
                                boxShadow: "0 1px 3px rgb(0 0 0 / 10%)",
                                cursor:
                                  lang === "ar-EG"
                                    ? activeIndex === 0
                                      ? "unset"
                                      : "pointer"
                                    : activeIndex ===
                                    eventDetails?.result?.photosAlbum
                                        ?.length 
                                    ? "unset"
                                    : "pointer",
                                backgroundColor:
                                  lang === "ar-EG"
                                    ? activeIndex === 0
                                      ? "rgb(243 123 128)"
                                      : "#DF1E26"
                                    : activeIndex ===
                                    eventDetails?.result?.photosAlbum
                                        ?.length 
                                    ? "rgb(243 123 128)"
                                    : "#DF1E26",
                                color: "#fff",
                              }}
                              className="buttons prv-slide"
                              onClick={lang === "ar-EG" ? prevSlide : nextSlide}
                            >
                              <IoIosArrowForward size={22} />
                            </ButtonBase>
                          </div>
                        </Row>
                      )}
                      <Swiper
                        modules={[Pagination, Autoplay]}
                        grabCursor={false}
                        key={lang}
                        dir={lang === "en-US" ? "ltr" : "rtl"}
                        slidesPerView={1}
                        spaceBetween={1}
                        autoplay={{
                          delay: "3000",
                        }}
                        centeredSlides={true}
                        slidesPerGroup={1}
                        pagination={{ clickable: true }}
                        navigation={{
                          prevEl: ".nxt-slide",
                          nextEl: ".prv-slide",
                        }}
                        className="mySwiper"
                        onSlideChange={(e) =>
                          setActiveIndex(swiper?.activeIndex)
                        }
                        onSwiper={(s) => {
                          setSwiper(s);
                        }}
                      >
                        <SwiperSlide>
                              <img
                              style={{
                                height:'600px',
                                objectFit:'fill'
                              }}
                                alt=""
                                src={`${
                                  eventDetails?.result?.photoE !== null
                                    ? `${langSwitching(
                                        lang,
                                        filesPaths.EventPhotoA,
                                        filesPaths.EventPhotoE
                                      )}/${eventDetails?.result?.id}/${langSwitching(
                                        lang,
                                        eventDetails?.result?.photoA,
                                        eventDetails?.result?.photoE
                                      )}`
                                    : `${filesPaths.EventPhotoA}/${eventDetails?.result?.id}/${eventDetails?.result?.photoA}`
                                }`}
                                className="w-100 d-block slider-album-img"
                              />
                            </SwiperSlide>
                        {eventDetails?.result?.photosAlbum?.map(
                          (item, index) => (
                            <SwiperSlide key={index}>
                              <img
                              style={{
                                height:'600px',
                                objectFit:'fill'
                              }}
                                alt=""
                                src={`${userPhoto}/Upload/PhotoLibraryAlbum/Photo/${eventDetails?.result?.photosAlbumId}/${item}`}
                                className="w-100 d-block slider-album-img"
                              />
                            </SwiperSlide>
                          )
                        )}
                      </Swiper>
                    </div>
                  )}
                </div>
                {/* <div className="event-more-details">
                  {attachmentSwitching(
                    lang,
                    eventDetails?.result?.photoA,
                    eventDetails?.result?.photoE
                  ) && (
                    <div
                      className="event-details-image"
                      // style={{
                      //   backgroundImage: `url("${
                      //     eventDetails?.result?.photoE !== null
                      //       ? `${langSwitching(
                      //           lang,
                      //           filesPaths.EventPhotoA,
                      //           filesPaths.EventPhotoE,
                      //         )}/${eventDetails?.result?.id}/${langSwitching(
                      //           lang,
                      //           eventDetails?.result?.photoA,
                      //           eventDetails?.result?.photoE,
                      //         )}`
                      //       : `${filesPaths.EventPhotoA}/${eventDetails?.result?.id}/${eventDetails?.result?.photoA}`
                      //   }")`,
                      // }}
                    >
                      <img
                        src={`${
                          eventDetails?.result?.photoE !== null
                            ? `${langSwitching(
                                lang,
                                filesPaths.EventPhotoA,
                                filesPaths.EventPhotoE
                              )}/${eventDetails?.result?.id}/${langSwitching(
                                lang,
                                eventDetails?.result?.photoA,
                                eventDetails?.result?.photoE
                              )}`
                            : `${filesPaths.EventPhotoA}/${eventDetails?.result?.id}/${eventDetails?.result?.photoA}`
                        }`}
                      />
                    </div>
                  )}
                </div> */}
              </div>
              <div className="event-details-description">
                <div className="row">
                  {langSwitching(
                    lang,
                    eventDetails?.result?.contentA,
                    eventDetails?.result?.contentE
                  ) && (
                    <div className="col-xl-8 col-lg-8 col-md-7 col-12 event-details-description-col">
                      <div className="event-decription-content ctr">
                        {" "}
                        <p>
                          {parse(
                            `${langSwitching(
                              lang,
                              eventDetails?.result?.contentA,
                              eventDetails?.result?.contentE
                            )}`
                          )}
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="col-xl-4 col-lg-4 col-md-5 col-12 more-events-col">
                    <MoreListing
                      favoriteRerender={favoriteRerender}
                      setFavoriteRerender={setFavoriteRerender}
                      // data={comingEvents?.result
                      //   ?.filter((x) => x.id != eventDetails?.result?.id)
                      //   ?.slice(0, 4)}
                      data={comingEvents?.result
                        ?.slice(0, 5)
                        ?.filter((x) => x.id != eventDetails?.result?.id)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingPopup />
      )}
      <Footer />
    </>
  );
};
export default EventDetails;
